import { forwardRef, type Ref, type SVGProps } from "react";
const IconHomeCompareOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M11.84 11.29a2 2 0 0 0-2.74 0l-6.47 6.12A2 2 0 0 0 2 18.86V28a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-9.13a2 2 0 0 0-.63-1.46zM17 28H4v-9.14l6.47-6.11L17 18.87z" />
    <path d="M7.71 21.29a1 1 0 0 0-1.42 1.42l2 2A1 1 0 0 0 9 25a1 1 0 0 0 .62-.22l5-4a1 1 0 1 0-1.24-1.56l-4.31 3.44zM25.88 8.22l-1.81 1.44-.36-.37a1 1 0 0 0-1.42 1.42l1 1A1 1 0 0 0 24 12a1 1 0 0 0 .62-.22l2.5-2a1 1 0 1 0-1.24-1.56" />
    <path d="m29.35 6.17-4.18-3.9a1 1 0 0 0-1.34 0l-4.18 3.9A2.1 2.1 0 0 0 19 7.69V14a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V7.69a2.1 2.1 0 0 0-.65-1.52M28 13h-7V7.63l3.5-3.25L28 7.63v.06z" />
  </svg>
);
const ForwardRef = forwardRef(IconHomeCompareOutlineSVG);
ForwardRef.displayName = "IconHomeCompareOutline";
export { ForwardRef as IconHomeCompareOutline };
